export const EDUCATOR = 'educator';
export const STUDENT = 'student';
